<template>
  <div style="display: contents">
    <b-row>
      <b-col md="12" class="mb-3">
        <div class="package-name-background p-2"><p>{{pack.name}}</p></div>
      </b-col>
      <b-col md="6" v-if="pack.included">
        <h6 class="package-title" v-translate>Services included</h6>
        <hr>
        <p style="white-space: pre-line;">{{ pack.included }}</p>
      </b-col>
      <b-col md="6" v-if="pack.notIncluded">
        <h6 class="package-title" v-translate>Services not included</h6>
        <hr>
        <p style="white-space: pre-line;">{{ pack.notIncluded }}</p>
      </b-col>
    </b-row>
    <FlightInfo :info="pack.flightInfo" v-if="pack.flightInfo" />
    <!-- TODO add bus info component -->
    <b-row v-if="showPrices">
      <b-col md="12">
        <div class="table-responsive">
          <h6 class="package-title" v-translate>Price details</h6>
          <table class="table table-sm text-center">
            <thead class="t-head thead-light text-center">
              <tr>
                <td v-translate>Room</td>
                <td></td>
                <td v-translate>Meal</td>
                <td v-translate>Booking price</td>
                <td v-translate>Sale</td>
                <td v-translate>Availability</td>
              </tr>
            </thead>
            <tbody>
              <template v-for="category in pack.categories">
                <category
                  :category="category"
                  :currency="currency"
                  :showCollapse="false"
                  :showBook="false"
                  :key="'categoryInfo' + category.id" />
              </template>
            </tbody>
          </table>
          <!-- <p class="package-warning" v-translate>*Attention! The reduced price is valid subject to availability!</p> -->
        </div>
      </b-col>
    </b-row>
    <b-row v-if="showExtras">
      <Extras :extras="pack.categories[0].extras" :currency="currency" />
    </b-row>
    <b-row v-if="showNotes">
      <b-col md="12">
        <!-- {{result}} -->
        <ul class="list-inline">
          <li class="list-group-item"><b v-translate>NOTE:</b> <span v-translate> the prices and supplements displayed are calculated by total reservation!</span> </li>
          <li class="list-group-item"><b v-translate>NOTE:</b> <span v-translate> additional / optional items that have the displayed value are not included in the booking price!</span></li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import category from '@/app/private/shared/components/category_result'
import FlightInfo from './flight_info'
import Extras from './extras'

export default {
  name: 'PackageInfo',
  props: {
    pack: {
      type: Object,
      required: true
    },
    currency: {
      type: String
    },
    showPrices: {
      type: Boolean,
      default: true
    },
    showExtras: {
      type: Boolean,
      default: true
    },
    showNotes: {
      type: Boolean,
      default: true
    }
  },
  components: { category, FlightInfo, Extras }
}
</script>
